<template>
  <div style="background-color: #f0f2f5;margin-bottom: -30px">
<!--    <img src="@/assets/images/policy/policies.png" alt="" class="fill-img" />-->
    <div class="declare_fill">
      <div class="module_content">
        <h3>项目内容</h3>
        <ul class="content-details">
          <li>
            <p><span>项目名称</span><span>{{ projectContent.title }}</span></p>
            <p><span>项目类型</span><span>{{ projectContent.type }}</span></p>
          </li>
        </ul>
      </div>
      <div class="module_content">
        <h3>企业信息</h3>
        <ul class="content-details">
          <li>
            <p><span>企业名称</span><span>{{ basicInfo.companyName }}</span></p>
            <p><span>统一社会信用代码</span><span>{{ basicInfo.licenseNum }}</span></p>
          </li>

          <li>
            <p><span>注册地址</span><span>{{ basicInfo.companyAddress }}</span></p>
            <p><span>企业银行账户名称</span><span>{{ basicInfo.companyName }}</span></p>
          </li>
          <li>
            <p><span>企业法人名称</span><span>{{ basicInfo.legalName }}</span></p>
            <p><span>企业法人电话</span><span>
            <el-input
              placeholder="请输入联系人电话"
              v-model="ruleForm.frPhone"
            ></el-input
            ></span></p>
          </li>
          <li>
            <p>
              <span>企业银行开户行</span>
              <span><el-input
                placeholder="请输入企业银行开户行"
                v-model="ruleForm.khh"
              ></el-input
              ></span>
            </p>
            <p>
              <span>企业银行账号</span>
              <span>
            <el-input
              placeholder="请输入企业银行账号"
              v-model="ruleForm.yhNum"
            ></el-input
            ></span>
            </p>

          </li>
          <li>
            <p>
              <span>联系人</span>
              <span><el-input
                placeholder="请输入联系人"
                v-model="ruleForm.lxrName"
              ></el-input
              ></span>
            </p>
            <p>
              <span>联系人电话</span>
              <span>
            <el-input
              placeholder="请输入联系人电话"
              v-model="ruleForm.lxrPhone"
            ></el-input
            ></span>
            </p>

          </li>

        </ul>
      </div>
      <div class="module_content">
        <h3>附件资料</h3>
        <div class="warning_message">
          <p>温馨提示：</p>
          <p>
            1、请按照附件要求，每条记录以一个文件形式上传，如果多个文件则先合并为一个文件（建议DOC或PDF或ZIP格式）后上传。
          </p>
          <p>
            2、文件不超过50M，格式为JPG、PNG、DOC、DOCX、WPS、PDF、XLS、XLSX、ZIP格式的文件。
          </p>
          <p>3、对于大于一页的单个附件，如审计报告等，建议采用PDF格式。</p>
          <p>
            4、附件材料的复印件或者原件，以扫描或者拍照的形式，确保足够清晰、否则将影响单位信息的审核，直至专项资金的审批拨付。
          </p>
          <p style="font-weight: bold;color: #000;font-size: 16px">本次需要提交的申报材料如下：</p>
          <div v-if="materialsList&&materialsList.length>0">
            <p v-for="(item,i) in materialsList" :key="i">
              {{i+1}}、{{item.materialName}}
            </p>
          </div>
          <div class="filelist">
            <label>附件</label>
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="headers"
              :before-remove="beforeRemove"
              multiple
              :limit="10"
              :on-exceed="handleExceed"
              :on-success="handleSuccess"
              :on-error="handleError"
              :file-list="fileList"
            ><!--:show-file-list="false"-->
              <el-button type="button"
              >附件上传</el-button
              >
            </el-upload>
          </div>
        </div>
      </div>
      <div class="module_content">
        <h3>信用承诺书</h3>
        <div class="commitment_msg">
          <div class="p_l20">
            <el-checkbox v-model="checked" disabled>
              阅读并同意
              <el-button type="text" @click="showPromise">
                《信用承诺书》
              </el-button>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="btn-list">
        <el-button type="primary" @click="submitApply">提交申请</el-button>
      </div>
    </div>

    <!-- 信用承诺书 -->
    <el-dialog
      v-if="promiseVisible"
      class="dialog"
      :visible.sync="promiseVisible"
      @close="handleClosePromise"
      width="60%"
      :before-close="handleClosePromise"
    >

      <div v-html="promiseContent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePromise()">取 消</el-button>
        <el-button
          type="primary"
          @click="
            handleClosePromise();
            checked = true;
          "
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStorage } from "@/common/utils";
import { getCompany, declareItemAdd } from "@/api/account";
import { detail_apply, declareGetById } from "@/api/policy";
import cookie from "js-cookie";
import config from "@/config";
export default {
  name: 'ReportDeclare',
  data() {
    return {
      uploadUrl: `${config.commonUrl}common/upload/fileTemplate`,
      headers: { accessToken: getStorage("token") },
      promiseVisible: false,
      checked: false,
      projectId: this.$route.query.projectId,
      directionId: this.$route.query.directionId,
      promiseContent: '',
      projectContent: {},
      basicInfo: {},
      materialsList: [],
      fileList: [],
      ruleForm: {
        frPhone: "",
        khh: "",
        yhNum: "",
        lxrName: "",
        lxrPhone: "",
        fileList: [],
      },
    };
  },
  mounted() {
    this.getProjectMessage()
    this.basicInfo = JSON.parse(localStorage.getItem("basic"));
    this.ruleForm.frPhone = JSON.parse(localStorage.getItem("basic")).mobile
    this.ruleForm.lxrPhone = JSON.parse(localStorage.getItem("basic")).mobile

    getCompany().then((res) => {
      if (res.data.code == 200) {
        this.basicInfo = res.data.result;
        this.promiseContent = `<div style="text-align: center;font-size: 1.6em;color: #333333;">信用承诺书</div>
        <div style="text-indent: 2em;line-height: 2.4;margin-top: 2em">
          为加快推进全国，加强企业诚信自律，逐步建立企业诚信经营长效机制，营造诚实守信的信用环境，树立诚信守法经营形象。我单位
          <span style="display: inline-block;min-width: 5rem;position: relative;text-indent: 0;margin: 0 0.625rem;">${ this.basicInfo.companyName }<i style="position: absolute;bottom: 0;left: 0;display: inline-block;width: 100%;height: 2px;background-color: #B1AEB1"></i></span>
          ，统一社会信用代码为
          <span style="display: inline-block;min-width: 5rem;position: relative;text-indent: 0;margin: 0 0.625rem;">${ this.basicInfo.licenseNum }<i style="position: absolute;bottom: 0;left: 0;display: inline-block;width: 100%;height: 2px;background-color: #B1AEB1"></i></span>
          ，郑重承诺如下：
        </div>
        <div style="text-indent: 2em;line-height: 2;margin-top: 0.8em">
          （一）严格遵守国家法律、法规、规章和政策规定，依法从事生产经营活动。
        </div>
        <div style="text-indent: 2em;line-height: 2;margin-top: 1em">
          （二）自觉接受政府、行业组织、社会公众、新闻舆论的监督，积极履行社会责任。
        </div>
        <div style="text-indent: 2em;line-height: 2;margin-top: 1em">
          （三）自我约束、自我管理，守合同、重信用，不制假售假、商标侵权、虚假宣传、违约毁约、恶意逃债、偷税漏税、价格欺诈、垄断和不正当竞争，切实维护消费者的合法权益。
        </div>
        <div style="text-indent: 2em;line-height: 2;margin-top: 1em">
          （四）发生违法失信行为，依照有关法律、行政法规规定接受行政执法部门给予的行政处罚、约束和惩戒，并依法承担相应责任。
        </div>
        <div style="text-indent: 2em;line-height: 2;margin-top: 1em">
          （五）本《信用承诺书》同意向社会公开。
        </div>
        <div style="width: 100%;overflow: hidden">
          <div style="width: 25em;float: right">
            <div style="text-indent: 2em;line-height: 2;margin-top: 1em;">
              <span>承诺单位：</span>
              <span>${ this.basicInfo.companyName }</span>
            </div>
            <div style="text-indent: 2em;line-height: 2;margin-top: 1em;">
              <span>法定代表人：</span>
              <span>${ this.basicInfo.legalName }</span>
            </div>
            <div style="text-indent: 2em;line-height: 2;margin-top: 0.5em;text-align: center">${ this.getCurrentTime() }</div>
          </div>
        </div>`
      }
    });
    declareGetById({
      id: this.$route.query.id,
    })
      .then((res) => {
        let { code, result, msg } = res.data;
        if (code === 200) {
          this.ruleForm.khh = result.khh
          this.ruleForm.yhNum = result.yhNum
          this.ruleForm.lxrName = result.lxrName
          let nameArr = [],urlArr = []
          if(result.fileName){
            nameArr = result.fileName.split(",")
          }
          if(result.fileUrl){
            urlArr = result.fileUrl.split(",")
          }
          let arr = [],newArr = []
          urlArr.map((item,i)=>{
            arr.push({file: nameArr[i], ossUrl: item})
            newArr.push({name:nameArr[i], url: item})
          })
          this.fileList = newArr
          this.ruleForm.fileList = arr
          this.checked = true
        }
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    getProjectMessage(){
      detail_apply(this.projectId).then(res=>{
        if(res.data.success){
          let datas = res.data.result
          this.projectContent.title = datas.title;
          if(this.directionId){
            if(datas.adminDeclareItemDirections&&datas.adminDeclareItemDirections.length>0){
              let directionIndex = datas.adminDeclareItemDirections.findIndex(item=>item.id == this.directionId)
              let directionItem = datas.adminDeclareItemDirections[directionIndex]
              this.projectContent.type = directionItem.attendance
              this.projectContent.money = directionItem.supportAmount
              this.materialsList = directionItem.adminDeclareItemMaterials
            }else{
              this.projectContent.type = ''
              this.projectContent.money = 0
              this.materialsList = []
            }
          }
        }
      })
    },
    submitApply() {
      if (cookie.get("accessToken")) {
        let formdata = {};

        for (let key in this.ruleForm) {
          if (key != "fileList") {
            if (!this.ruleForm[key]) {
              console.log(this.ruleForm, 88888)
              this.$message.warning("请填写企业信息");
              return;
            } else {
              formdata[key] = this.ruleForm[key]
            }
          } else {
            if (this.ruleForm.fileList.length) {
              console.log(this.ruleForm.fileList, 87654)
              let nameArr = [],fileArr = []
              this.ruleForm.fileList.map(item=>{
                nameArr.push(item.file)
                fileArr.push(item.ossUrl)
              })
              formdata.fileName = nameArr.join(",")
              formdata.fileUrl = fileArr.join(",")
            } else {
              formdata.fileName = ""
              formdata.fileUrl = ""
            }
          }
        }
        if (!this.checked) {
          this.$message({
            message: "请先阅读并同意信用承诺书",
            type: "warning",
          });
          return;
        }
        formdata["companyName"] = this.basicInfo.companyName;//企业名称
        formdata["zhmc"] = this.basicInfo.companyName;//企业银行账户名称
        formdata["cnh"] = this.promiseContent;//承诺函信息
        formdata["frName"] = this.basicInfo.legalName;//法人名称
        formdata["companyAddress"] = this.basicInfo.companyAddress;//企业地址
        formdata["licenseNum"] = this.basicInfo.licenseNum;//企业统一社会信用代码
        formdata["name"] = this.projectContent.title;//申报项目名称
        formdata["supportAmount"] = this.projectContent.money;//扶持金额
        formdata["type"] = this.projectContent.type;//扶持金额
        formdata["itemDirectionId"] = this.$route.query.directionId;
        formdata["itemId"] = this.$route.query.projectId;
        declareItemAdd(formdata).then((res) => {
          if (res.data.code == 200) {
            this.$message.success("申报成功");
            setTimeout(() => {
              this.$router.push({
                path: "/pcm/apply",
              });
            }, 1000);
          }
        });
      } else {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      }
    },
    getCurrentTime() {
      //获取当前时间并打印
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      return yy + "年" + mm + "月" + dd + "日";
    },
    showPromise() {
      this.promiseVisible = true;
    },
    handleClosePromise() {
      this.promiseVisible = false;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
        .then(() => {
          let deleteIndex = this.ruleForm.fileList.findIndex(item=> item.ossUrl == file.url)
          this.ruleForm.fileList.splice(deleteIndex,1)
          // this.ruleForm.fileList.splice(deleteIndex,1)
          /*let arr = fileList.filter((obj) => obj.uid != file.uid);
          this.fileList = [];
          arr.forEach((item) => {
            this.fileList.push(item.response.result.id);
          });*/
          return true;
        })
        .catch(() => {});
    },
    onChange(file, fileList) {
      file.status = "success";
      this.fileList = fileList;
      console.log(this.fileList, fileList, "filelist");
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.fileList.push(res.result.id);
        this.ruleForm.fileList.push(res.result);
      } else {
        this.$message.warning(res.message);
      }
    },
    handleError(err) {
      this.$message.warning(JSON.parse(err.message).message);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
        files.length + fileList.length
          } 个文件`
      );
    },
  },
}
</script>

<style lang="scss" >
.fill-img {
  margin-top: 10px;
}

.declare_fill {
  width: 1200px;
  margin: 0px auto;
  padding: 20px 0 50px;
  .module_content{
    background-color: #ffffff;
    margin: 20px 0;
    padding: 0 5px;
    h3 {
      padding: 15px;
      margin: 0;
      border-bottom: 1px solid #ececec;
      color: #3a3a3a;
      font-weight: bold;
    }
    .content-details {
      margin: 0;
      padding: 10px 17px 25px;
      li {
        width: 100%;
        display: flex;
        list-style: none;
        font-size: 16px;
        color: #999;
        line-height: 50px;
        /*margin: 25px 0;*/
        p{
          width: 50%;
          margin: 0;
          font-size: 14px;
          span {
            &:first-child {
              color: #333;
              margin-right: 10px;
              width: 130px;
              display: inline-block;

            }
            .el-input {
              width: 300px;
            }
          }
        }
      }
    }
    .warning_message {
      padding: 10px 17px 25px;
      p {
        padding-left: 15px;
        color: #666666;
        font-size: 14px;
        line-height: 24px;
        span {
          color: rgb(249, 84, 17);
        }
      }
      .filelist {
        margin-top: 20px;
        margin-left: 17px;
        display: flex;
        align-items: center;
        label {
          margin-right: 20px;
        }
        .upload-demo{
          width: 80%;
          .el-upload{
            .el-button{
              /*background-color: #1990ff;*/
              color: #ffffff;
              background-color: #4988df;
              border-color: #4988df;
            }
          }
        }
      }
      .file-lists{
        width: 90%;
        list-style: none;
        margin-left: 28px;
        li{
          line-height: 26px;
          font-size: 14px;
          a{
            color: #666666;
            font-size: 14px;
            &:hover{
              color: #1990ff;
            }
          }
        }
      }
    }
    .commitment_msg{
      padding: 10px 0 20px;
    }
    .file_first_page {
      width: 80%;
      margin: 40px auto;
      .page_subtitle {
        border-bottom: 1px solid #666666;
        text-align: right;
        padding-bottom: 10px;
        padding-right: 5%;
      }
      .project_message {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 200px;
        padding: 0 5%;
        p {
          &:first-child {
            .add_line {
              display: inline-block;
              margin: 3px 5px;
              text-decoration: underline;
            }
          }
        }
      }
      h3 {
        text-align: center;
        font-size: 28px;
        margin: 80px 0 200px;
      }
      .base_message {
        width: 100%;
        margin-bottom: 150px;
        p {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
          span {
            display: flex;
            justify-content: center;
            &:first-child {
              flex: 2;
              justify-content: flex-end;
            }
            &.add_line {
              flex: 3;
              justify-content: flex-start;
              margin-bottom: 3px;
              position: relative;
              &::after {
                position: absolute;
                width: 60%;
                height: 1px;
                left: 0;
                bottom: -4px;
                background-color: #666666;
                content: "";
              }
            }
          }
        }
      }
    }
  }



  .btn-list {
    width: 100%;
    display: flex;
    justify-content: center;
    .el-button {
      a {
        text-decoration: none;
        color: #ffffff;
      }
    }
  }
}
.wrapper {
  .under-line {
    display: inline-block;
    min-width: 80px;
    position: relative;
    text-indent: 0;
    margin: 0 10px;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      border: 1px solid #b1aeae;
      left: 0;
      bottom: -2px;
    }
  }
  .indent_2 {
    text-indent: 2em;
  }
  .lh_2 {
    line-height: 2;
  }
  .footer-box {
    text-align: right;
    // .text-box{
    // 	display: inline-block;
    // 	min-width: 100px;
    // }
    // .flex-end{
    // 	display: flex;
    // 	justify-content: end;
    // }
    .end-box {
      display: flex;
      justify-items: end;

      .flex-width {
        width: 42%;
        text-align: left;
        display: flex;
        .text-box {
          flex: 1;
        }
      }
    }
  }
}
@media only screen and (max-width: 1440px) {
  .declare_fill {
    width: 1200px;
  }
}
</style>